import styled from "styled-components";

export const AlarmEventOverviewWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: stretch;
    width: 100%;
    height: 100%;
    padding: 0 10px;
`

export const AlarmEventTotalWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: stretch;
    width: 33.3%;
    height: 100%;
    background-color: #ecdaa8a6;
    margin: 10px 2px 0px 0px;
`

export const AlarmEventTodayWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: stretch;
    width: 33.3%;
    height: 100%;
    background-color: #88e2f860;
    margin: 10px 2px 0px 0px;
`

export const AlarmEventUnackedWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: stretch;
    width: 33.3%;
    height: 100%;
    background-color: #5fa8864b;
    margin: 10px 0px 0px 0px;
`

export const Icon = styled.div`
    display: flex;
    align-items: left;
    justify-content: center;
    margin-left: 5px;

   .anticon {
       font-size: 25px;
   }    
`

export const TextWrapper = styled.div`
    display: flex;
    justify-content: center;
    flex: 1;
    flex-direction: column;
`

export const Text = styled.div`
   font-size: 16px;
   font-weight: bold;
   margin: 0 1px;
   padding: 5px 0;
   text-align: center;
   color: #5f5e5e;
   white-space: nowrap;
   overflow: hidden;
`;

